import React from "react";
import { useTranslation } from "react-i18next";
import { post } from "api/api/axiosSetup";
import PaymentLinkDetailModal from "features/order-taking/pages/take-order/steps/order-confirmation/modals/payment-links/detail.modal";
import { StatusButton, Status } from "./Index";

const PaymentLinkInfo = ({ orderInfo, children }) => {

  const { t } = useTranslation();

  const [viewPaymentLinkInfoModal, setViewPaymentLinkInfoModal] =
    React.useState(false);
  const [paymentLinkInfo, setPaymentLinkInfo] = React.useState({});

  const status = React.useMemo(
    () =>
      paymentLinkInfo?.linkStatus
        ? Status[paymentLinkInfo?.linkStatus]
        : Status[orderInfo?.orderCheckoutOnlinePaymentMetadata?.linkStatus],
    [paymentLinkInfo, orderInfo?.orderCheckoutOnlinePaymentMetadata?.linkStatus, orderInfo?.orderCheckoutOnlinePaymentMetadata?.cartId]
  );

  const updateOrderPaymentLinkStatus = async (data) => {
    try {
        await post("order/admin-order-taking/update-order-payment-link-status", {
            orderId: orderInfo?._id,
            brandId: orderInfo?.brandId,
            linkStatus: data?.linkStatus,
            paymentStatus: data?.paymentStatus,
            transactionDetail: data?.transactionDetail,
        })
    } catch (error) {
        console.error(error);
    }
  }
   
  const getPaymentLinkInfo = async () => {
    const result = await post(
      "payment-links/get-payment-link-info-by-cart-id",
      {
        cartId: orderInfo?.orderCheckoutOnlinePaymentMetadata?.cartId,
        brandId: orderInfo?.brandId,
      }
    );
    if (result?.success === 1 && result?.data) {
      setPaymentLinkInfo(result?.data);
      if(result?.data?.linkStatus !== orderInfo?.orderCheckoutOnlinePaymentMetadata?.linkStatus){
        updateOrderPaymentLinkStatus(result?.data)
      }
    }
  };

  React.useEffect(() => {
    if (
      orderInfo?.orderCheckoutOnlinePaymentMetadata?.cartId
    ) {
      getPaymentLinkInfo();
    }
  }, [orderInfo]);


  React.useLayoutEffect(() => {
    setPaymentLinkInfo({});
    return () => {
      setPaymentLinkInfo({});
    }
  }, []);

  return (
    <>
      {children}
      <StatusButton text="Payment Link Status" status={status} onClick={() => setViewPaymentLinkInfoModal(true)} />
     
      <PaymentLinkDetailModal
        open={viewPaymentLinkInfoModal}
        onClose={() => setViewPaymentLinkInfoModal(false)}
        modalInfo={{
          ...orderInfo?.orderCheckoutOnlinePaymentMetadata,
          ...(paymentLinkInfo || {}),
        }}
      />
    </>
  );
};

export default PaymentLinkInfo;
